import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step10 } from '../../../../../shared/models/component-messages/mapaIN/step10';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';
import { CTRL_418 } from '../../../../validators/418/ctrl418';
import { MapaINControlNames } from '../../service/mapaINControleNames';

@Component({
  selector: 'app-step10',
  templateUrl: './step10.component.html'
})
export class Step10Component implements OnInit {

  private LOG: LogService = new LogService(Step10Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	

	@Input() uid = '';


	public step10 = new Step10();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {
  }

  public getUid() {
		return this.uid;
	}

}
